import React, { useEffect, useState, forwardRef } from "react";
import DaumPostcode from "react-daum-postcode";
import {
  Button,
  Dialog,
  Slide,
  AppBar,
  Box,
  Link,
  Divider,
  TextField,
  InputAdornment,
  Typography
} from "@mui/material";
import pr from "../lib/pr";
import { configState } from "../lib/State";
import axios from 'axios';
import Swal from "sweetalert2";
import get_cid from "../lib/get_cid";

function RegisterFormPhone(props) {
  const {setAuthParent, setPhoneParent} = props;
  const [phone, setPhone] = useState("");
  const [auth, setAuth] = useState("");
  const [mode, setMode] = useState(''); // 기본, 인증
  const cid = get_cid();

  const onSubmit = async() => {    
    const data = {
        cid:cid,
        phone:phone,        
    }
    let result = await axios.post(configState.api+'/gympass/join_auth',data);
    if(result.data.success===0) {
        Swal.fire(result.data.msg);
        return;
    }
    else {
        Swal.fire('인증 번호를 발송했습니다.')
        setMode('문자발송');
        return;
    }
  };

  return (
    <>
      
      { mode==='' &&
      <>
      <Box display="flex" sx={{ mt: 0.5 }}>
        <Box sx={{ width: "100%" }}>
          <TextField
            fullWidth
            autoComplete="off"
            name="phone"
            label="연락처"
            size="small"
            variant="standard"
            onChange={(e) => {
              setPhone(e.target.value);
              setPhoneParent(e.target.value);
            }}
            value={phone}
            InputProps={{endAdornment:
              <InputAdornment position="end">
                <Button
                  onClick={onSubmit}
                  edge="end"
                  sx={{
                    color: 'rgba(0, 0, 0, 0.6)'
                  }}
                >
                  SMS인증
                </Button>
                {/* <Typography>SMS인증</Typography> */}
              </InputAdornment>
            }}
          >
            
          </TextField>
        </Box>
        {/* <Box sx={{ ml: 1 }}>
              <Button variant="contained" onClick={onSubmit}>
                SMS인증
              </Button>
            </Box> */}
      </Box>
      <Box sx={{ mt: 0.5, fontSize: 14 }}>
        연락처는 -없이 숫자만 입력하세요.(필수)
      </Box>
      </> }

      { mode==='문자발송' &&
      <>       
        <Box display="flex" sx={{ mt: 0.5 }}>
            <Box sx={{ width: "40%" }}>
            <TextField
                fullWidth
                autoComplete="off"
                name="auth"
                label="인증번호"
                size="small"
                onChange={(e) => {
                  setAuth(e.target.value);
                  setAuthParent(e.target.value);
                }}
                value={auth}
            ></TextField>
            </Box>        
        </Box>    
        <Box sx={{ mt: 0.5, fontSize: 14 }}>
            인증번호를 입력하세요. (5분 내에 입력)
        </Box>
      </> }

      {/* <Button variant="contained" onClick={()=>setMode('문자발송')}>버튼</Button> */}
    </>
  );
}

export default RegisterFormPhone;
